import { Avatar, Box, Flex, Typography } from "../../../ppui";
import { formatIndianCurrency } from "../../../utils/common";

export const bankHeaders = (currentPage, rowsPerPage) => [
  {
    key: "salary_id",
    label: "SL No.",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_name",
    label: "Employee Name",
    align: "left",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (rows) => (
      <>
        <Flex alignItems="center">
          <Avatar
            className={"avatarHover"}
            size="sm"
            color="secondary"
            initials={`${rows.employee_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box>
            {rows.employee_name}
            <Typography
              color={"default"}
              colorVariant={"light"}
              variant={"body2"}
              mb={"0"}
            >
              #{rows.employee_code}
            </Typography>
          </Box>
        </Flex>
      </>
    ),
  },
  {
    key: "bank_name",
    label: "Bank Name",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.bank_name? row?.employees?.bank_name: '--'
  },
  {
    key: "branch_name",
    label: "Branch Name",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.branch_name? row?.employees?.branch_name: '--'
  },
  
  {
    key: "payable_days",
    label: "Account Number",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.account_number? row?.employees?.account_number: '--'
  },
  {
    key: "ncp_days",
    label: "IFSC Code",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.ifsc_code? row?.employees?.ifsc_code : '--'
  },
  {
    key: "ot_hour",
    label: "Payment Through (NEFT/IMPS)",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.payment_through? row?.employees?.payment_through : '--'
  },

  {
    key: "CTC_salary",
    label: "Net Pay",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) =>  row?.payable_salary ? formatIndianCurrency(row?.payable_salary.toFixed()) : "00",
  },

  // {
  //   key: "basic_salary",
  //   label: "Date",
  //   align: "right",
  //   isShortable: false,
  //   isVisible: true,
  //   getValue: (row) =>  row?.payable_basic_salary ? formatIndianCurrency(row?.payable_basic_salary.toFixed()) : "--",
  // },
];

export const SalaryRows = [
  {
    slNo: 1,
    name: "Arjun Sharma",
    employeecode: "EMP009",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 2,
    name: "Jane Smith",
    employeecode: "EMP005",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },

  {
    slNo: 3,
    name: "Arjun Sharma",
    employeecode: "EMP003",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 4,
    name: "Jane Smith",
    employeecode: "EMP004",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },

  {
    slNo: 5,
    name: "Arjun Sharma",
    employeecode: "EMP005",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 6,
    name: "Jane Smith",
    employeecode: "EMP006",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },
];
